import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { ResultReportsListingModel } from 'common/models/page-models/reports/result-reports/result-report-grid.model';
import { ResultChartsModel } from 'common/models/page-models/reports/result-reports/result-reports-charts.model';
import { ResultReportsModel } from 'common/models/page-models/reports/result-reports/result-reports-data.model';
import { ResultReportsGridPostParams } from 'common/models/page-models/reports/result-reports/result-reports-grid-params';


@Injectable({
    providedIn: 'root'
})
export class ResultReportsDataService extends GridDataService<ResultReportsListingModel, ResultReportsModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.fetchReportData, http, ss);
    }

    createInstance(): ResultReportsListingModel {
        return new ResultReportsListingModel();
    }

    getDeleteUrl() {
        return '';
    }

    override getGridParams(param): GridPostParams {
        return new ResultReportsGridPostParams();
    }

    override transformDataModel(data: any[], param: any) {
        super.transformDataModel(data, param);
        if (data.hasOwnProperty(param)) {
            data[param].forEach(element => {
                element.isKT = element.overallKtStatus === 0 ? 'No' : 'Yes';
            });
        } else {
            // console.log('No records found for given combination');
            this.ss.showError('No records found for given combination')
        }
        return data;
    }

    override modifyGridPostParams(queryParams) {
        let payload = this.getGridParams(queryParams);
        if (queryParams.transferData !== null) {
            payload['batch_search'] = queryParams.transferData.selectedBatch === null ? '' : queryParams.transferData.selectedBatch;
            payload['region_search'] = queryParams.transferData.selectedRegion === null ? '' : queryParams.transferData.selectedRegion;
            payload['branch_search'] = queryParams.transferData.selectedBranch === null ? '' : queryParams.transferData.selectedBranch;
            payload['state_search'] = queryParams.transferData.selectedState === null ? '' : queryParams.transferData.selectedState;
            payload['gender_search'] = queryParams.transferData.selectedGender === null ? '' : queryParams.transferData.selectedGender;
            payload['status_search'] = queryParams.transferData.selectedStatus === null ? '' : queryParams.transferData.selectedStatus;
            payload['ktStatus'] = queryParams.transferData.selectedKT === null ? '' : queryParams.transferData.selectedKT;
            payload['scoreFilter'] = queryParams.transferData.selectedScore === null ? '' : queryParams.transferData.selectedScore;
            payload['uploadedFilter'] = queryParams.transferData.selectedUploadFilter === null ? '' : queryParams.transferData.selectedUploadFilter;
            payload['semFilter'] = queryParams.transferData.selectedSem === null ? '' : queryParams.transferData.selectedSem;
        }
        return payload;
    }

    override prepareChartsData(apiData) {
        // console.log(apiData);

        const chartsModel = new ResultChartsModel();
        let averageScore1 = 0;
        let averageScore2 = 0;
        let averageScore3 = 0;
        let averageScore4 = 0;
        let averageScore5 = 0;
        let averageScore6 = 0;
        let averageScore7 = 0;
        let averageScore8 = 0;

        const eligibleStudents = apiData.filter((data) => data.semestersCompleted > 0);
        // console.log(eligibleStudents);



        const uploadedStudents = eligibleStudents.filter((data) => data.totalnumberOfSemScoreUploaded > 0);
        const nonUploadedStudents = eligibleStudents.filter((data) => data.totalnumberOfSemScoreUploaded === 0);
        const ktStudents = eligibleStudents.filter((data) => data.overallKtStatus === 1);
        const nonKtStudents = eligibleStudents.filter((data) => data.overallKtStatus === 0);
        const sem1EligibleStudents = apiData.filter((data) => (data.semestersCompleted > 1 || data.semestersCompleted === 1));
        const sem1UploadedStudents = sem1EligibleStudents.filter((data) => data.totalnumberOfSemScoreUploaded > 0);
        const sem1NonUploadedStudents = sem1EligibleStudents.filter((data) => data.totalnumberOfSemScoreUploaded === 0);
        const sem1KtStudents = sem1EligibleStudents.filter((data) => data.overallKtStatus === 1);
        const sem1NoKtStudents = sem1EligibleStudents.filter((data) => data.overallKtStatus === 0);
        sem1UploadedStudents.forEach((data) => {
            averageScore1 = averageScore1 + parseFloat(data.semester1);
        });
        const totalUploaded1Students = sem1UploadedStudents.length;
        averageScore1 = (averageScore1 / totalUploaded1Students);


        const sem2EligibleStudents = apiData.filter((data) => (data.semestersCompleted > 2 || data.semestersCompleted === 2));
        const sem2UploadedStudents = sem2EligibleStudents.filter((data) => data.totalnumberOfSemScoreUploaded > 1);
        const sem2NonUploadedStudents = sem2EligibleStudents.filter((data) => (data.totalnumberOfSemScoreUploaded === 1 || data.totalnumberOfSemScoreUploaded < 1));
        const sem2KtStudents = sem2EligibleStudents.filter((data) => data.overallKtStatus === 1);
        const sem2NoKtStudents = sem2EligibleStudents.filter((data) => data.overallKtStatus === 0);
        sem2UploadedStudents.forEach((data) => {
            averageScore2 = averageScore2 + parseFloat(data.semester2);
        });
        const totalUploaded2Students = sem2UploadedStudents.length;
        averageScore2 = (averageScore2 / totalUploaded2Students);


        const sem3EligibleStudents = apiData.filter((data) => (data.semestersCompleted > 3 || data.semestersCompleted === 3));
        const sem3UploadedStudents = sem3EligibleStudents.filter((data) => data.totalnumberOfSemScoreUploaded > 2);
        const sem3NonUploadedStudents = sem3EligibleStudents.filter((data) => (data.totalnumberOfSemScoreUploaded === 2 || data.totalnumberOfSemScoreUploaded < 2));
        const sem3KtStudents = sem3EligibleStudents.filter((data) => data.overallKtStatus === 1);
        const sem3NoKtStudents = sem3EligibleStudents.filter((data) => data.overallKtStatus === 0);
        sem3UploadedStudents.forEach((data) => {
            averageScore3 = averageScore3 + parseFloat(data.semester3);
        });
        const totalUploaded3Students = sem3UploadedStudents.length;
        averageScore3 = (averageScore3 / totalUploaded3Students);


        const sem4EligibleStudents = apiData.filter((data) => (data.semestersCompleted > 4 || data.semestersCompleted === 4));
        const sem4UploadedStudents = sem4EligibleStudents.filter((data) => data.totalnumberOfSemScoreUploaded > 3);
        const sem4NonUploadedStudents = sem4EligibleStudents.filter((data) => (data.totalnumberOfSemScoreUploaded === 3 || data.totalnumberOfSemScoreUploaded < 3));
        const sem4KtStudents = sem4EligibleStudents.filter((data) => data.overallKtStatus === 1);
        const sem4NoKtStudents = sem4EligibleStudents.filter((data) => data.overallKtStatus === 0);
        sem4UploadedStudents.forEach((data) => {
            averageScore4 = averageScore4 + parseFloat(data.semester4);
        });
        const totalUploaded4Students = sem4UploadedStudents.length;
        averageScore4 = (averageScore4 / totalUploaded4Students);


        const sem5EligibleStudents = apiData.filter((data) => (data.semestersCompleted > 5 || data.semestersCompleted === 5));
        const sem5UploadedStudents = sem5EligibleStudents.filter((data) => data.totalnumberOfSemScoreUploaded > 4);
        const sem5NonUploadedStudents = sem5EligibleStudents.filter((data) => (data.totalnumberOfSemScoreUploaded === 4 || data.totalnumberOfSemScoreUploaded < 4));
        const sem5KtStudents = sem5EligibleStudents.filter((data) => data.overallKtStatus === 1);
        const sem5NoKtStudents = sem5EligibleStudents.filter((data) => data.overallKtStatus === 0);
        sem5UploadedStudents.forEach((data) => {
            averageScore5 = averageScore5 + parseFloat(data.semester5);
        });
        const totalUploaded5Students = sem5UploadedStudents.length;
        averageScore5 = (averageScore5 / totalUploaded5Students);


        const sem6EligibleStudents = apiData.filter((data) => (data.semestersCompleted > 6 || data.semestersCompleted === 6));
        const sem6UploadedStudents = sem6EligibleStudents.filter((data) => data.totalnumberOfSemScoreUploaded > 5);
        const sem6NonUploadedStudents = sem6EligibleStudents.filter((data) => (data.totalnumberOfSemScoreUploaded === 5 || data.totalnumberOfSemScoreUploaded < 5));
        const sem6KtStudents = sem6EligibleStudents.filter((data) => data.overallKtStatus === 1);
        const sem6NoKtStudents = sem6EligibleStudents.filter((data) => data.overallKtStatus === 0);
        sem6UploadedStudents.forEach((data) => {
            averageScore6 = averageScore6 + parseFloat(data.semester6);
        });
        const totalUploaded6Students = sem6UploadedStudents.length;
        averageScore6 = (averageScore6 / totalUploaded6Students);


        const sem7EligibleStudents = apiData.filter((data) => (data.semestersCompleted > 7 || data.semestersCompleted === 7));
        const sem7UploadedStudents = sem7EligibleStudents.filter((data) => data.totalnumberOfSemScoreUploaded > 6);
        const sem7NonUploadedStudents = sem7EligibleStudents.filter((data) => (data.totalnumberOfSemScoreUploaded === 6 || data.totalnumberOfSemScoreUploaded < 6));
        const sem7KtStudents = sem7EligibleStudents.filter((data) => data.overallKtStatus === 1);
        const sem7NoKtStudents = sem7EligibleStudents.filter((data) => data.overallKtStatus === 0);
        sem7UploadedStudents.forEach((data) => {
            averageScore7 = averageScore7 + parseFloat(data.semester7);
        });
        const totalUploaded7Students = sem7UploadedStudents.length;
        averageScore7 = (averageScore7 / totalUploaded7Students);


        const sem8EligibleStudents = apiData.filter((data) => (data.semestersCompleted === 8));
        const sem8UploadedStudents = sem8EligibleStudents.filter((data) => data.totalnumberOfSemScoreUploaded > 7);
        const sem8NonUploadedStudents = sem8EligibleStudents.filter((data) => (data.totalnumberOfSemScoreUploaded === 7 || data.totalnumberOfSemScoreUploaded < 7));
        const sem8KtStudents = sem8EligibleStudents.filter((data) => data.overallKtStatus === 1);
        const sem8NoKtStudents = sem8EligibleStudents.filter((data) => data.overallKtStatus === 0);
        sem8UploadedStudents.forEach((data) => {
            averageScore8 = averageScore8 + parseFloat(data.semester8);
        });
        const totalUploaded8Students = sem8UploadedStudents.length;
        averageScore8 = (averageScore8 / totalUploaded8Students);

        chartsModel.uploadedChart.options = {
            chart: {
                type: 'pie',
                width: 320, // Adjust chart width
                height: 300 // Adjust chart height
            },
            credits: {
                enabled: false // Disable the Highcharts credits
            },
            title: {
                text: 'Total Students:  ' + eligibleStudents.length,
                style: {
                    color: '#000000',
                    fontSize: '1em',
                }
            },
            series: [
                {
                    type: 'pie', // Add the type property here
                    data: [
                        {
                            name: 'Uploaded:' + uploadedStudents.length,
                            y: uploadedStudents.length,
                            // y: 5,
                            color: '#37897c'
                        },
                        {
                            name: 'Non-Uploaded:' + nonUploadedStudents.length,
                            y: nonUploadedStudents.length,
                            // y: 8,
                            color: '#2db9a3'
                        }
                    ],
                    dataLabels: {
                        enabled: false,
                        inside: true,
                        distance: 6 // Adjust the distance of labels from the slices
                    }
                }
            ]
        };

        chartsModel.uploadedChart.data = {
            uploadedData: uploadedStudents.length,
            uploadedColor: '#37897c',
            nonUploadedData: nonUploadedStudents.length,
            nonUploadedColor: '#2db9a3'
        }

        chartsModel.semWiseUploadedChart = {
            chart: {
                type: 'column'
            },
            title: {
                text: 'Uploaded Vs Not-Uploaded Semester Wise',
                align: 'left'
            },
            xAxis: {
                categories: ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4', 'Sem 5', 'Sem 6', 'Sem 7', 'Sem 8'],
                crosshair: true,
                accessibility: {
                    description: 'Semesters'
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Count'
                }
            },
            tooltip: {
                valueSuffix: ''
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [
                {
                    name: 'Uploaded',
                    data: [sem1UploadedStudents.length, sem2UploadedStudents.length, sem3UploadedStudents.length, sem4UploadedStudents.length, sem5UploadedStudents.length, sem6UploadedStudents.length, sem7UploadedStudents.length, sem8UploadedStudents.length]
                },
                {
                    name: 'Not Uploaded',
                    data: [sem1NonUploadedStudents.length, sem2NonUploadedStudents.length, sem3NonUploadedStudents.length, sem4NonUploadedStudents.length, sem5NonUploadedStudents.length, sem6NonUploadedStudents.length, sem7NonUploadedStudents.length, sem8NonUploadedStudents.length]
                }
            ]
        };

        chartsModel.kTChart.options = {
            chart: {
                type: 'pie',
                width: 320, // Adjust chart width
                height: 300 // Adjust chart height
            },
            credits: {
                enabled: false // Disable the Highcharts credits
            },
            title: {
                text: 'Total Students:  ' + eligibleStudents.length,
                style: {
                    color: '#000000',
                    fontSize: '1em',
                }
            },
            series: [
                {
                    type: 'pie', // Add the type property here
                    data: [
                        {
                            name: 'KT:' + ktStudents.length,
                            y: ktStudents.length,
                            // y: 5,
                            color: '#ff6969'
                        },
                        {
                            name: 'No KT:' + nonKtStudents.length,
                            y: nonKtStudents.length,
                            // y: 8,
                            color: '#ffe279'
                        }
                    ],
                    dataLabels: {
                        enabled: false,
                        inside: true,
                        distance: 6 // Adjust the distance of labels from the slices
                    }
                }
            ]
        };

        chartsModel.kTChart.data = {
            ktData: ktStudents.length,
            ktColor: '#ff6969',
            nonKtData: nonKtStudents.length,
            nonKtColor: '#ffe279'
        }

        chartsModel.semWiseKtChart = {
            chart: {
                type: 'column'
            },
            title: {
                text: 'KT Vs Non-KT Semester Wise',
                align: 'left'
            },
            xAxis: {
                categories: ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4', 'Sem 5', 'Sem 6', 'Sem 7', 'Sem 8'],
                crosshair: true,
                accessibility: {
                    description: 'Semesters'
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Count'
                }
            },
            tooltip: {
                valueSuffix: ''
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [
                {
                    name: 'KT',
                    data: [sem1KtStudents.length, sem2KtStudents.length, sem3KtStudents.length, sem4KtStudents.length, sem5KtStudents.length, sem6KtStudents.length, sem7KtStudents.length, sem8KtStudents.length]
                },
                {
                    name: 'No KT',
                    data: [sem1NoKtStudents.length, sem2NoKtStudents.length, sem3NoKtStudents.length, sem4NoKtStudents.length, sem5NoKtStudents.length, sem6NoKtStudents.length, sem7NoKtStudents.length, sem8NoKtStudents.length]
                }
            ]
        };

        chartsModel.semWiseScoreChart = {
            chart: {
                type: "column",
            },
            title: {
                align: "left",
                text: "Average Score Semester Wise",
            },
            accessibility: {
                announceNewData: {
                    enabled: true,
                },
            },
            xAxis: {
                type: "category",
                title: {
                    text: 'Semesters',
                },
            },
            yAxis: {
                title: {
                    text: "Average Score",
                },
            },
            legend: {
                enabled: false,
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: "{point.y:.1f}%",
                    },
                },
            },

            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat:
                    '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b><br/>',
            },

            series: [
                {
                    name: "Score",
                    colorByPoint: true,
                    data: [
                        {
                            name: "sem1",
                            y: (averageScore1),
                            drilldown: "sem1",
                            color: "#37897c",
                        },
                        {
                            name: "sem2",
                            y: (averageScore2),
                            drilldown: "sem2",
                            color: "#37897c",
                        },
                        {
                            name: "sem3",
                            y: (averageScore3),
                            drilldown: "sem3",
                            color: "#37897c",
                        },
                        {
                            name: "sem4",
                            y: (averageScore4),
                            drilldown: "sem4",
                            color: "#37897c",
                        },
                        {
                            name: "sem5",
                            y: (averageScore5),
                            drilldown: "sem5",
                            color: "#37897c",
                        },
                        {
                            name: "sem6",
                            y: (averageScore6),
                            drilldown: "sem6",
                            color: "#37897c",
                        },
                        {
                            name: "sem7",
                            y: (averageScore7),
                            drilldown: "sem7",
                            color: "#37897c",
                        },
                        {
                            name: "sem8",
                            y: (averageScore8),
                            drilldown: "sem8",
                            color: "#37897c",
                        },
                    ]
                },
            ],
        };





        return chartsModel;
    }
}
